import { FIGMA_COLORS, TYPOGRAPHY } from "components-redesign/styles";
import { makeStyles } from "components/mui-core";
import React from "react";

const useStyles = makeStyles()({
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 32,
    height: 32,
    borderRadius: 100,
    // the primary container at 30%, which is how the design tints it
    backgroundColor: `${FIGMA_COLORS.primaryContainerLight}4D`,
    ...TYPOGRAPHY.labelLarge,
    fontWeight: 600,
    color: FIGMA_COLORS.primaryLight,
  },
});

/** The numbered marker that heads each step of a walkthrough. */
function StepBadge({ children }: { children: React.ReactNode }) {
  const { classes } = useStyles();

  return <div className={classes.badge}>{children}</div>;
}

export default StepBadge;
